export const common = {
  actions: {
    actions: 'Thao tác',
    save: 'Lưu',
    cancel: 'Hủy',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    view: 'Xem',
    detail: 'Chi tiết',
    list: 'Danh sách',
    show: 'Hiển thị',
    update: 'Cập nhật',
    duplicate: 'Sao chép',
    download: 'Tải xuống',
    downloadTemplate: 'Tải file mẫu',
    downloadErrorFile: 'Tải file lỗi',
    upload: 'Tải lên',
    print: 'In',
    close: 'Đóng',
    open: 'Mở',
    add: 'Thêm',
    remove: 'Xóa',
    select: 'Chọn',
    clear: 'Xóa',
    submit: 'Gửi',
    reset: 'Đặt lại',
    confirmDelete: 'Xác nhận xóa',
    confirmAction: 'Xác nhận hành động',
    approve: 'Phê duyệt',
    reject: 'Từ chối',
    archive: 'Lưu trữ',
    unarchive: 'Khôi phục',
    activate: 'Kích hoạt',
    deactivate: 'Không kích hoạt',
    /** Ngừng / cho phép hoạt động — dùng footer panel expand. */
    stopActivity: 'Ngừng hoạt động',
    allowActivity: 'Cho phép hoạt động',
    enable: 'Bật',
    disable: 'Tắt',
    lock: 'Khóa',
    unlock: 'Mở khóa',
    importData: 'Nhập dữ liệu',
    exportData: 'Xuất dữ liệu',
    generateReport: 'Tạo báo cáo',
    viewReport: 'Xem báo cáo',
    send: 'Gửi',
    receive: 'Nhận',
    process: 'Xử lý',
    validate: 'Xác thực',
    complete: 'Hoàn thành',
    cancelAction: 'Hủy bỏ hành động',
    create: 'Tạo',
    back: 'Quay lại',
    skip: 'Bỏ qua',
    next: 'Tiếp theo',
    previous: 'Trước đó',
    confirm: 'Xác nhận',
    apply: 'Áp dụng',
    search: 'Tìm kiếm',
    selectNone: 'Không chọn',
    filter: 'Lọc',
    export: 'Xuất',
    import: 'Nhập',
    stop: 'Dừng',
    previewBeforeCreate: 'Xem trước khi tạo',
    refresh: 'Làm mới',
    imagePreview: 'Xem hình ảnh',
    hideFilter: 'Ẩn bộ lọc',
    showFilter: 'Hiện bộ lọc',
    comingSoon: 'Tính năng đang phát triển',
  },
  status: {
    active: 'Kích hoạt',
    inactive: 'Không kích hoạt',
    listActive: 'Đang hoạt động',
    listInactive: 'Ngừng hoạt động',
    pending: 'Đang chờ',
    completed: 'Đã hoàn thành',
    cancelled: 'Đã hủy',
    draft: 'Bản nháp',
  },
  messages: {
    success: 'Thành công',
    updateSuccess: 'Cập nhật thành công',
    createSuccess: 'Tạo thành công',
    deleteSuccess: 'Xóa thành công',
    error: 'Đã xảy ra lỗi',
    warning: 'Cảnh báo',
    info: 'Thông tin',
    loading: 'Đang tải...',
    noData: 'Không có dữ liệu',
    confirmDelete: 'Bạn có chắc chắn muốn xóa mục này không?',
    confirmDeleteCode: 'Mục sẽ bị xóa: {code}',
    noImages: 'Không có hình ảnh nào',
    checkRequiredFields: 'Vui lòng kiểm tra các trường bắt buộc',
    'image/*': 'Chỉ cho phép tệp hình ảnh',
    cantUploadImage: 'Không thể tải lên hình ảnh',
    uploadImageError: 'Lỗi khi tải lên hình ảnh',
    uploading: 'Đang tải hình ảnh...',
    pasteNoImage: 'Clipboard không có ảnh. Hãy copy ảnh hoặc dán link http(s).',
    uploadSuccess: 'Hình ảnh đã được tải lên thành công',
    uploadMore: 'Tải thêm hình ảnh',
    dragHere: 'Kéo thả hình ảnh vào đây',
    orClickHere: 'hoặc nhấp vào đây để chọn',
    dragHereOrClick: 'Kéo thả hình ảnh vào đây hoặc nhấp để chọn',
  },
  validation: {
    required: 'Trường này là bắt buộc',
    email: 'Định dạng email không hợp lệ',
    minLength: 'Tối thiểu {min} ký tự',
    maxLength: 'Tối đa {max} ký tự',
    numeric: 'Chỉ cho phép số',
  },
  date: {
    today: 'Hôm nay',
    yesterday: 'Hôm qua',
    tomorrow: 'Ngày mai',
    thisWeek: 'Tuần này',
    lastWeek: 'Tuần trước',
    thisMonth: 'Tháng này',
    lastMonth: 'Tháng trước',
    thisQuarter: 'Quý này',
    lastQuarter: 'Quý trước',
    thisYear: 'Năm nay',
    lastYear: 'Năm trước',
    last7Days: '7 ngày gần đây',
    last30Days: '30 ngày gần đây',
    pickDate: 'Chọn ngày',
  },
  sortBy: 'Sắp xếp theo',
  sortDirection: 'Sắp xếp',
  asc: 'Tăng dần',
  desc: 'Giảm dần',
  table: {
    pageSize: 'Hiển thị:',
    perPage: 'trang',
    showingRange: 'Hiển thị {from} - {to} / Tổng số {total}',
    /** Footer bảng danh sách sản phẩm (giống dòng chữ Kiot Hàng hóa). */
    showingRangeProducts: 'Hiển thị {from} - {to} / Tổng số {total} hàng',
    /** Tiêu đề cột nút xem / sửa / xóa (thống nhất mọi danh sách). */
    rowActions: 'Thao tác',
  },
  labels: {
    code: 'Mã',
  },
  account: 'Tài khoản',
  profile: 'Hồ sơ',
  role: {
    super_admin: 'Super admin',
    admin: 'Admin',
    manager: 'Quản lý',
    standard_user: 'Nhân viên',
    customer: 'Khách hàng',
  },
  total: 'Tổng',
  yes: 'Có',
  no: 'Không',
  stt: 'STT',
  noData: 'Không có dữ liệu',
  getTax: 'Lấy thuế',
  themeAccent: {
    aria: 'Chọn màu chủ đề giao diện',
  },
  importModal: {
    fileSelected: 'File đã chọn: {name}',
  },
  importTemplate: {
    success: 'Tải file mẫu thành công',
    failed: 'Tải file mẫu thất bại',
  },
  importResult: {
    errorColumnHeader: 'Lỗi',
    downloadErrorFileFailed: 'Không thể tạo file lỗi',
  },
  import: {
    stubDescription:
      'Chọn file Excel (.xlsx) theo mẫu. Dữ liệu gửi qua API import thử nghiệm — thay endpoint khi backend có API chính thức.',
    stubSuccess: 'Import thành công (API thử).',
    stubFailed: 'Import thất bại.',
    noData: 'Không có dòng dữ liệu hợp lệ trong file.',
    noSheet: 'File Excel không có sheet dữ liệu.',
    notSupportedByBackend: 'Chức năng import Excel chưa được backend hỗ trợ cho module này.',
  },
  export: {
    exportFile: 'Xuất file',
    exportExcelButton: 'Xuất Excel',
    exportOverview: 'Xuất tổng quan',
    exportDetail: 'Xuất chi tiết',
    exportSuccess: 'Đã tải file Excel.',
    selectRowForDetail: 'Vui lòng chọn một dòng trên bảng để xuất chi tiết.',
    selectRowsFirst: 'Vui lòng tích chọn ít nhất một dòng để xuất.',
    exportSelectedVisible: 'Đã chọn — cột đang hiện ({count})',
    exportSelectedAllColumns: 'Đã chọn — tất cả cột ({count})',
    exportSelectedWithLinesVisible: 'Đã chọn + chi tiết — cột đang hiện ({count})',
    exportSelectedWithLinesAll: 'Đã chọn + chi tiết — tất cả cột ({count})',
    exportFilterVisible: 'Theo lọc — cột đang hiện',
    exportFilterAllColumns: 'Theo lọc — tất cả cột',
    exportFilterWithLinesVisible: 'Theo lọc + chi tiết — cột đang hiện',
    exportFilterWithLinesAll: 'Theo lọc + chi tiết — tất cả cột',
    lineCode: 'Mã hàng',
    lineName: 'Tên hàng',
    lineQty: 'Số lượng',
    linePrice: 'Đơn giá',
    lineAmount: 'Thành tiền',
    lineUnit: 'ĐVT',
    lineDiscount: 'Giảm giá dòng',
    lineSellPrice: 'Giá bán',
    lineSharedDiscount: 'Giảm giá chung',
    lineOtherFee: 'Thu khác',
    lineTotal: 'Tổng cộng',
    lineWeight: 'Số cân (kg)',
    lineVolume: 'Số khối (m³)',
    lineNote: 'Ghi chú',
    customerCode: 'Mã KH',
    customerName: 'Tên khách hàng',
    branch: 'Chi nhánh',
    seller: 'Người bán',
    time: 'Thời gian',
    status: 'Trạng thái',
    infoSheet: 'Thông tin phiếu',
    listSheet: 'Danh sách hóa đơn',
    linesSheet: 'Chi tiết hàng',
    infoField: 'Trường',
    infoValue: 'Giá trị',
  },
  /** Chuỗi dùng chung cho `ConfirmDialog` (BaseModal) — module nào cũng dùng được. */
  confirmDialog: {
    /** Khi danh sách code > maxInlineCodes: "... và {count} mã khác" */
    bulkAndMore: '... và {count} mã khác',
  },
  /** Chuỗi dùng chung cho tab POS Bán hàng (right-click context menu + bulk close). */
  unsaved: {
    closeTitle: 'Đóng phiếu chưa lưu?',
    closeBody: 'Dữ liệu đang nhập chưa được lưu. Đóng sẽ mất các thay đổi này.',
    discard: 'Đóng, bỏ thay đổi',
  },
  tabs: {
    closeTab: 'Đóng tab',
    closeOthers: 'Đóng tất cả tab khác',
    closeRight: 'Đóng các tab bên phải',
    bulkCloseTitle: 'Đóng nhiều tab?',
    bulkCloseBody:
      'Có {count} tab đang có thay đổi chưa lưu. Đóng sẽ làm mất các thay đổi này.',
    closeAllDrafts: 'Đóng hết phiếu nháp',
    closeAllDraftsTitle: 'Đóng hết phiếu nháp?',
    closeAllDraftsBody:
      'Toàn bộ {count} phiếu nháp đang mở sẽ bị xóa, dữ liệu chưa lưu sẽ mất. Sau đó mở một phiếu trống mới.',
  },
  /** Lọc chi nhánh dùng chung trên sidebar list. */
  filter: {
    chiNhanh: 'Chi nhánh',
    chiNhanhAll: 'Tất cả chi nhánh',
    chiNhanhSearch: 'Tìm chi nhánh',
    chiNhanhEmpty: 'Không có chi nhánh',
    chonTatCa: 'Chọn tất cả',
    boChonTatCa: 'Bỏ chọn tất cả',
  },
  /** Menu ẩn/hiện cột danh sách (ProductListColumnMenu — dùng chung mọi module). */
  columnPicker: {
    selectAll: 'Chọn tất cả',
    deselect: 'Bỏ chọn',
    default: 'Mặc định',
    sort: 'Sắp xếp',
    sortDone: 'Xong sắp xếp',
    resetOrder: 'Đặt lại thứ tự',
    sortHint: 'Tích cột cần sắp, rồi bấm ↑/↓ trên cột khác để đặt trên/dưới',
    fixedLeft: 'Cố định trái',
    fixedRight: 'Cố định phải',
    columnsTitle: 'Các cột',
    sortColumnsTitle: 'Sắp xếp cột',
    placeAbove: 'Đặt phía trên',
    placeBelow: 'Đặt phía dưới',
    autoFit: 'Tự động vừa độ rộng cột',
    viewMenu: 'Giao diện',
    defaultView: 'Mặc định',
    defaultViewHint: 'Kiểu thường, độ rộng cột ban đầu',
    autoFitShort: 'Vừa cột',
    excelView: 'Excel',
    excelViewHint: 'Kẻ lưới, giảm padding ô',
    ultraView: 'Siêu gọn',
    ultraViewHint: 'Kẻ lưới, chữ nhỏ, ô sát — xem được nhiều dòng nhất',
    resizeHandle: 'Kéo để chỉnh độ rộng cột, nhấp đúp để vừa nội dung',
    resetWidths: 'Mặc định',
    resetWidthsHint: 'Về độ rộng cột mặc định (bỏ chỉnh trên máy này)',
    gridLines: 'Kẻ ô',
    gridLinesHint: 'Bật/tắt đường kẻ giữa các cột',
    actionsColumn: 'Cột {name}',
    decreaseFixed: 'Giảm số cột cố định',
    increaseFixed: 'Tăng số cột cố định',
  },
  /** Modal in phiếu sau khi tạo ĐH / HĐ / TH. */
  voucherPrint: {
    title: 'In phiếu',
    codeLabel: 'Mã phiếu',
    templateLabel: 'Mẫu in',
    printButton: 'In',
    exportExcelButton: 'Xuất Excel',
    editTemplateButton: 'Chỉnh sửa mẫu in',
    loading: 'Đang tải phiếu in…',
    loadingPreview: 'Đang xem trước mẫu in…',
    loadError: 'Không tải được dữ liệu in',
    printError: 'Không in được phiếu',
    missingId: 'Thiếu mã phiếu để in',
    batchCount: '{count} phiếu',
    batchModeOnce: 'In 1 lần',
    batchModeOnceHint: 'Một hộp thoại in — mỗi hóa đơn sang trang mới, không chung trang',
    batchModeEach: 'Mỗi HĐ 1 lần',
    batchModeEachHint: 'Mở hộp thoại in riêng cho từng hóa đơn',
    noTemplate: 'Chưa có mẫu in',
    noTemplateHint: 'Chưa có mẫu in cho loại phiếu này — hệ thống sẽ dùng mẫu mặc định khi bấm In.',
    defaultBadge: 'Mặc định',
    previewButton: 'In thử',
    previewTitle: 'In thử',
    previewDraftBadge: 'Bản nháp — chưa lưu',
    previewEmpty: 'Chưa có dữ liệu để in thử',
    pdfGroup: 'Mẫu PDF',
    excelGroup: 'Mẫu Excel',
    builtInTemplate: 'Mẫu dựng sẵn',
    printSelected: 'In ({count})',
    exportSelected: 'Xuất Excel ({count})',
    selectAll: 'Chọn tất cả',
    previewPane: 'Xem trước',
    templatesPane: 'Mẫu in',
    paperSize: '{w} × {h} mm',
    zoomOut: 'Thu nhỏ',
    zoomIn: 'Phóng to',
    zoomReset: '100%',
  },
  voucherQr: {
    column: 'QR',
    view: 'Xem QR',
    title: 'Mã QR phiếu',
    copyCode: 'Sao chép mã',
    copied: 'Đã sao chép mã phiếu',
    copyError: 'Không sao chép được',
    download: 'Tải ảnh QR',
    linkedCodes: 'Mã liên kết',
  },
  disabledReason: {
    processing: 'Đang xử lý, vui lòng chờ…',
    noCode: 'Phiếu chưa có mã nên chưa tạo được QR',
    notSaved: 'Phiếu chưa được lưu',
    printUnavailable: 'Chưa cấu hình mẫu in cho loại phiếu này',
  },
  filePreview: {
    title: 'Xem trước file',
    kindPdf: 'PDF',
    kindExcel: 'Excel',
    kindImage: 'Ảnh',
    kindOther: 'File',
    prev: 'Trước',
    next: 'Sau',
    prevFile: 'File trước',
    nextFile: 'File sau',
    openOriginal: 'Mở link gốc',
    openFile: 'Mở file',
    missingUrl: 'Thiếu URL file để xem trước.',
    excelNoSheet: 'File Excel không có sheet dữ liệu.',
    excelRowLimit: 'Chỉ xem trước {n} dòng đầu — tải file để xem đầy đủ.',
    unsupported: 'Định dạng này chưa hỗ trợ xem trước trong trình duyệt. Hãy mở link gốc hoặc tải xuống.',
  },
  entityCode: {
    detailTitle: 'Chi tiết {name}',
    detailTitleWithCode: 'Chi tiết {name} — {code}',
    types: {
      hoaDon: 'hóa đơn',
      traHang: 'phiếu trả hàng',
      datHang: 'đơn đặt hàng',
      phieuXuatKho: 'phiếu xuất kho',
      phieuNhapKho: 'phiếu nhập kho',
      chuyenHang: 'phiếu chuyển hàng',
      kiemKe: 'phiếu kiểm kê',
      yeuCauSuaChua: 'yêu cầu sửa chữa',
      yeuCauXuatHoaDon: 'yêu cầu xuất hóa đơn',
      datHangNcc: 'đơn đặt hàng nhà cung cấp',
      phieuNhanHang: 'phiếu nhận hàng',
      khachHang: 'khách hàng',
      product: 'hàng hóa',
    },
  },
}
